import React from "react"
import styled from "styled-components"

const Footer = styled.footer`
    margin-top: 3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

const CopyrightWrapper = styled.p`
    padding: 0.75rem;
    font-size: 0.75rem;
    margin: 0;
`

const LinksWrapper = styled.div`
  padding: 0 0.75rem 0.75rem 0.75rem;
  font-size: 0.75rem;
  display: flex;
  gap: 1rem;
`

const FooterLink = styled.a`
  color: inherit;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

export default function LayoutFooter() {
  return (
    <Footer>
      <CopyrightWrapper>Copyright: Rafał Pydyniak</CopyrightWrapper>
      <LinksWrapper>
        <FooterLink href="https://innray.com">
          Moja firma związana z usługami Liferay i AWS: InnRay
        </FooterLink>
        <FooterLink href="https://www.linkedin.com/company/innray/" target="_blank" rel="noopener noreferrer">
          LinkedIn InnRay
        </FooterLink>
        <FooterLink href="http://www.linkedin.com/in/pydyniak" target="_blank" rel="noopener noreferrer">
          Osobisty LinkedIn
        </FooterLink>
      </LinksWrapper>
    </Footer>
  )
}